import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { SwitchCurrencyIcon } from '@root/shared/ui-kit'

import {
  positionTableCurrencyTypeAtom,
  togglePositionTableCurrencyType,
} from '../atoms'

import type { ClassNameProps } from '@root/shared/react'

type PositionTableSellHeaderProps = {} & ClassNameProps

export const PositionTableSellHeader: React.FC<
  PositionTableSellHeaderProps
> = ({ className }) => {
  const [currencyType] = useAtom(positionTableCurrencyTypeAtom)
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)

  const toggleCurrencyType = useAction(togglePositionTableCurrencyType)

  return (
    <Root
      className={className}
      onClick={(e) => {
        e.stopPropagation()
        toggleCurrencyType()
      }}
    >
      <div>{currencyType === 'native' ? nativeCurrency.ticker : 'USD'}</div>
      <SwitchCurrencyIcon size={16} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;

  cursor: pointer;

  color: var(--text-11);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--text-12);
  }
`
